export default "__VITE_ASSET__UiW5EudQ__"